import { BrowserRouter, Navigate } from 'react-router-dom';
import { ScrollToTop } from 'src/features/brightsaas/components/ScrollToTop';
import { Route, Routes } from 'react-router-dom';
import { AuthLandingPage } from 'src/features/MP/components/templates/AuthLandingPage';
import { MarketingPageContainer } from 'src/features/MP/components/organisms/MarketingPageContainer';
import { AccountCreationPage } from 'src/features/Signup/components/templates/AccountCreationPage';
import MarketingPageHeader from 'src/features/MP/components/organisms/MarketingPageHeader';
// import { MarketingLandingPage } from 'src/features/MP/components/templates/MarketingLandingPage';
// import ContactPage from 'src/features/MP/components/templates/ContactPage';
// import TermsPage from 'src/features/MP/components/templates/TermsPage';
// import CookiePolicyPage from 'src/features/MP/components/templates/CookiePolicyPage';
// import { PrivacyPolicyPage } from 'src/features/MP/components/templates/PrivacyPolicyPage';
// import { DPAPage } from 'src/features/MP/components/templates/DPAPage';
// import ServiceDescriptionPage from 'src/features/MP/components/templates/ServiceDescriptionPage';
// import PricingPage from 'src/features/MP/components/templates/PricingPage';
// import ProductsPage from 'src/features/MP/components/templates/ProductsPage';
// import { SubprocessorsPage } from 'src/features/MP/components/templates/SubprocessorsPage';
// import { SaasTermsPage } from 'src/features/MP/components/templates/SaasTerms';
// import { UserTermsPage } from 'src/features/MP/components/templates/UserTerms';
// import { TermsOfExchangePage } from 'src/features/MP/components/TermsOfExchange';
// import CompanyPage from 'src/features/MP/components/templates/CompanyPage';
// import ResourcesPage from 'src/features/MP/components/templates/ResourcesPage';
// import GettingStartedGuidePage from 'src/features/MP/components/templates/ResourcesPage/GettingStartedGuidePage';
// import { PricingPlansPage } from 'src/features/MP/components/templates/ResourcesPage/PricingPlansPage';
// import InviteYourTeamPage from 'src/features/MP/components/templates/ResourcesPage/InviteYourTeamPage';
// import TrackIssuesPage from 'src/features/MP/components/templates/ResourcesPage/TrackIssuesPage';
// import WorkspaceSettingsPage from 'src/features/MP/components/templates/ResourcesPage/WorkspaceSettingsPage';
// import HowIntegrationsWorkPage from 'src/features/MP/components/templates/ResourcesPage/HowIntegrationsWorkPage';
// import CustomSetupPage from 'src/features/MP/components/templates/ResourcesPage/CustomSetupPage';
// import FaqSupportPage from 'src/features/MP/components/templates/ResourcesPage/FaqSupportPage';
// import BlogPage from 'src/features/MP/components/templates/BlogPage';
// import BlogPostPage from 'src/features/MP/components/templates/BlogPostPage';
import { IS_DEV } from 'src/constants';
import { BrightSaaSLayout } from 'src/features/brightsaas/components/BrightSaaSLayout';
import { HomePage } from 'src/features/brightsaas/pages/HomePage';
import { PricingPage as BrightSaaSPricingPage } from 'src/features/brightsaas/pages/PricingPage';
import { AboutPage } from 'src/features/brightsaas/pages/AboutPage';
import { TermsPage as BrightSaaSTermsPage } from 'src/features/brightsaas/pages/TermsPage';
import { PrivacyPage as BrightSaaSPrivacyPage } from 'src/features/brightsaas/pages/PrivacyPage';
import { CookiePage as BrightSaaSCookiePage } from 'src/features/brightsaas/pages/CookiePage';
import { ServiceDescriptionPage as BrightSaaSServiceDescriptionPage } from 'src/features/brightsaas/pages/ServiceDescriptionPage';
import { SubprocessorsPage as BrightSaaSSubprocessorsPage } from 'src/features/brightsaas/pages/SubprocessorsPage';
import { DPAPage as BrightSaaSDPAPage } from 'src/features/brightsaas/pages/DPAPage';
import { TermsOfExchangePage as BrightSaaSTermsOfExchangePage } from 'src/features/brightsaas/pages/TermsOfExchangePage';
import { SaasTermsPage as BrightSaaSSaasTermsPage } from 'src/features/brightsaas/pages/SaasTermsPage';
import { UserTermsPage as BrightSaaSUserTermsPage } from 'src/features/brightsaas/pages/UserTermsPage';
import { IntegrationsPage as BrightSaaSIntegrationsPage } from 'src/features/brightsaas/pages/IntegrationsPage';
import { RefundPolicyPage as BrightSaaSRefundPolicyPage } from 'src/features/brightsaas/pages/RefundPolicyPage';
import { CareersPage } from 'src/features/brightsaas/pages/CareersPage';
import { CareerDetailPage } from 'src/features/brightsaas/pages/CareerDetailPage';

// force dark theme
const registerPageElement = (
  <>
    <MarketingPageHeader showLinks={false} allowDarkTheme />
    <AccountCreationPage />
  </>
);

export const Landings = () => {
  if (IS_DEV) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<AuthLandingPage />} />
          {/* temporary */}
          <Route path="/register" element={registerPageElement} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <BrightSaaSLayout>
              <HomePage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/pricing"
          element={
            <BrightSaaSLayout>
              <BrightSaaSPricingPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/about"
          element={
            <BrightSaaSLayout>
              <AboutPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/terms"
          element={
            <BrightSaaSLayout>
              <BrightSaaSTermsPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <BrightSaaSLayout>
              <BrightSaaSPrivacyPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/cookie-policy"
          element={
            <BrightSaaSLayout>
              <BrightSaaSCookiePage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/service-description"
          element={
            <BrightSaaSLayout>
              <BrightSaaSServiceDescriptionPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/subprocessors"
          element={
            <BrightSaaSLayout>
              <BrightSaaSSubprocessorsPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/dpa"
          element={
            <BrightSaaSLayout>
              <BrightSaaSDPAPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/terms-of-exchange"
          element={
            <BrightSaaSLayout>
              <BrightSaaSTermsOfExchangePage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/saas-terms"
          element={
            <BrightSaaSLayout>
              <BrightSaaSSaasTermsPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/user-terms"
          element={
            <BrightSaaSLayout>
              <BrightSaaSUserTermsPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/integrations"
          element={
            <BrightSaaSLayout>
              <BrightSaaSIntegrationsPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/refund-policy"
          element={
            <BrightSaaSLayout>
              <BrightSaaSRefundPolicyPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/careers"
          element={
            <BrightSaaSLayout>
              <CareersPage />
            </BrightSaaSLayout>
          }
        />
        <Route
          path="/careers/:slug"
          element={
            <BrightSaaSLayout>
              <CareerDetailPage />
            </BrightSaaSLayout>
          }
        />
        <Route path="/register" element={registerPageElement} />
        <Route
          path="*"
          element={
            <MarketingPageContainer>
              <Routes>
                {/*<Route path="/old-home" element={<MarketingLandingPage />} />*/}
                {/*<Route path="/old/contact" element={<ContactPage />} />*/}
                {/*<Route path="/old/terms" element={<TermsPage />} />*/}
                {/*<Route*/}
                {/*  path="/old/cookie-policy"*/}
                {/*  element={<CookiePolicyPage />}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  path="/old/privacy-policy"*/}
                {/*  element={<PrivacyPolicyPage />}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  path="/old/subprocessors"*/}
                {/*  element={<SubprocessorsPage />}*/}
                {/*/>*/}
                {/*<Route path="/old/dpa" element={<DPAPage />} />*/}
                {/*<Route*/}
                {/*  path="/old/service-description"*/}
                {/*  element={<ServiceDescriptionPage />}*/}
                {/*/>*/}
                {/*<Route path="/old/saas-terms" element={<SaasTermsPage />} />*/}
                {/*<Route path="/old/user-terms" element={<UserTermsPage />} />*/}
                {/*<Route*/}
                {/*  path="/old/terms-of-exchange"*/}
                {/*  element={<TermsOfExchangePage />}*/}
                {/*/>*/}
                {/*<Route path="/old/pricing" element={<PricingPage />} />*/}
                {/*<Route path="/old/company" element={<CompanyPage />} />*/}
                {/*<Route path="/resources" element={<ResourcesPage />} />*/}
                {/*<Route*/}
                {/*  path="/resources/getting-started"*/}
                {/*  element={<GettingStartedGuidePage />}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  path="/resources/pricing-plans"*/}
                {/*  element={<PricingPlansPage />}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  path="/resources/invite-your-team"*/}
                {/*  element={<InviteYourTeamPage />}*/}
                {/*/>*/}
                {/*<Route path="/resources/track-issues" element={<TrackIssuesPage />} />*/}
                {/*<Route*/}
                {/*  path="/resources/workspace-settings"*/}
                {/*  element={<WorkspaceSettingsPage />}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  path="/resources/how-integrations-work"*/}
                {/*  element={<HowIntegrationsWorkPage />}*/}
                {/*/>*/}
                {/*<Route path="/resources/custom-setup" element={<CustomSetupPage />} />*/}
                {/*<Route path="/resources/faq-support" element={<FaqSupportPage />} />*/}
                {/*<Route path="/old/product" element={<ProductsPage />} />*/}
                {/*<Route path="/blog" element={<BlogPage />} />*/}
                {/*<Route path="/blog/:slug" element={<BlogPostPage />} />*/}
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </MarketingPageContainer>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
